export default __webpack_public_path__ + "static/media/ChryslerBG.892cadd6.png";